var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","dark":_vm.dark}},[_c('v-card-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }